export var ResponseStatus;
(function(ResponseStatus) {
    ResponseStatus["OK"] = "ok";
})(ResponseStatus || (ResponseStatus = {}));
